import { useMemo } from "react";
import { useSelector } from "react-redux";

const useDetails = () => {
  const details = useSelector((state) => state?.auth?.details);
  return useMemo(() => details, [details]);
};

export default useDetails;
